<template>
  <div class="new-container" v-loading.fullscreen.lock="loading">
    <div class="new-header">
      <div class="header-info">
        <div class="info-img">
          <img v-if="currentBaseInfo.photo" :src="currentBaseInfo.photo" alt>
          <img v-else src="@/images/doctor.png" alt>
        </div>
        <div class="info-name">
          <div class="pername">您好！{{currentBaseInfo.name}}</div>
          <div class="welcome">欢迎使用天坛工会管理系统</div>
        </div>
      </div>
    </div>
    <div class="new-content">
      <div class="content-card" v-for="item in newList" :key="item.id" @click="openPage(item)">
        <div class="card-title">
          <img v-if="item.listType=='welfare'" src="@/images/fl-red.png" alt srcset>
          <img v-else src="@/images/hd.png" alt srcset>
          <span v-if="item.listType=='welfare'">{{item.welfareName}}</span>
          <span v-else>{{item.name}}</span>
        </div>
        <div class="card-content">
          <div class="content" v-html="item.content"></div>
          <div class="date" v-if="item.listType=='welfare'">{{ item.startTime&&item.startTime.split(' ')[0] }} ~ {{ item.finishTime && item.finishTime.split(' ')[0]}}</div>
          <div class="date" v-else>{{ item.startTime }} ~ {{ item.endTime}}</div>
        </div>
        <div class="card-footer">
          <div class="footer-left">查看详情</div>
          <div class="footer-right">
            <span v-if="item.listType=='welfare'" class="text wefale">节日慰问领取</span>
            <span
              v-else
              :class="[item.activityType == '2'?'all':'need','text']"
            >{{ item.activityType != '2' ? '打卡活动' : '报名活动' }}</span>
            <span class="icon">
              <i class="cubeic-arrow"></i>
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script type="text/ecmascript-6">
import { getNewestList } from "@/common/api";
export default {
  data() {
    return {
      newList: [],
      loading: false,
      currentBaseInfo: {}
    };
  },
  created() {},
  mounted() {
    this.currentBaseInfo = JSON.parse(localStorage.getItem("loginInfo"));
    this.getNewtList();
  },
  methods: {
    getNewtList() {
      this.loading = true;
      getNewestList({
        userId: this.currentBaseInfo.id
      }).then(res => {
        if (res.code == 200) {
          this.loading = false;
          res.data.forEach(item => {
            item.content = item.content
              .replace(new RegExp("&lt;", "g"), "<")
              .replace(new RegExp("&quot;", "g"), "")
              .replace(new RegExp("&gt;", "g"), ">");
          });
          this.newList = res.data;      
        } else {
          this.loding = false;
        }
      });
    },
    openPage(item) {
      if (item.listType == "welfare") {
        this.$router.push({
          path: "/welfareDetail",
          query: {
            welfareId: item.welfareId,
            status: item.status
          }
        });
      } else {
        if (item.activityType == 2) {
          //需报名参加
          this.$router.push({
            path: "/signupActivity",
            query: {
              id: item.id,
              status: item.status,
              level:item.level,
            }
          });
        } else {
          this.$router.push({
            path: "/directActivity",
            query: {
              id: item.id,
              status: item.status,
              signGroupId:item.signGroupId || '',
            }
          });
        }
      }
    }
  },
  beforeRouteLeave(to, from, next) {
    if (to.name === "personnelManagement") {
      next({ name: "personalCenter" });
    } else {
      next(); // 注意：这边next必须要写
    }
  }
};
</script>
  
<style lang="stylus" type="stylesheet/stylus">
.new-container {
  background:#F0F0F4;
  .new-header {
    height: 120px;
    background: url('../../assets/images/bg.png');
    padding: 0.7rem 0.5rem 0 0.5rem;

    .header-info {
      display: flex;

      .info-img {
        flex: 1;

        img {
          width: 71px;
        }
      }

      .info-name {
        flex: 5;
        padding-left: 0.3rem;

        .pername {
          height: 50px;
          line-height: 50px;
          font-size: 20px;
          color: rgba(255, 255, 255, 1);
        }

        .welcome {
          font-size: 14px;
          color: rgba(255, 255, 255, 1);
        }
      }
    }
  }

  .new-content {
    position: relative;
    top: -30px;
    padding: 0 0.3rem;

    .content-card {
      padding: 0.12rem 0.3rem;
      border-radius: 10px;
      margin-bottom: 0.3rem;

      .card-title {
        display: flex;
        align-items: center;
        color: rgba(53, 53, 53, 1);
        padding: 0.2rem 0;
        border-bottom: 1px solid rgba(229, 229, 229, 1);
        span {
          font-size:16px;
          font-family:PingFang SC;
          font-weight:600;
          color:rgba(53,53,53,1);
        }
        img {
          width: 14px;
          margin-right:5px;
        }
      }

      .card-content {
        padding: 0.25rem 0 0.3rem 0;
        border-bottom: 1px solid rgba(229, 229, 229, 1);

        .content {
          height: 25px;
          line-height: 25px;
          font-size: 14px;
          color: rgba(136, 136, 136, 1);
          word-break: break-all;
          text-overflow: ellipsis;
          overflow: hidden;
          white-space: nowrap;
          font-family:PingFang SC;
          font-weight:400;
          p {
            text-overflow: ellipsis;
            overflow: hidden;
            white-space: nowrap;
          }
          img {
            display: none;
          }
        }

        .date {
          font-size:12px;
          font-family:PingFang SC;
          font-weight:500;
          color:rgba(172,172,183,1);
          line-height:24px;
        }
      }

      .card-footer {
        display: flex;
        height: 30px;
        align-items: center;

        .footer-left {
          flex: 1;
          font-size: 12px;
          color: rgba(172, 172, 183, 1);
        }

        .footer-right {
          flex: 1;
          display: flex;
          justify-content: flex-end;

          .text {
            display:inline-block;
            text-align: center;
            padding:3px 5px;
            font-size: 12px;
            font-weight: 600;
          }

          .wefale {
            background: rgba(255, 229, 229, 1);
            color: rgba(255, 89, 89, 1);
          }

          .need {
            background: rgba(228, 237, 255, 1);
            color: rgba(79, 135, 251, 1);
          }

          .all {
            background: rgba(233, 244, 244, 1);
            color: rgba(56, 199, 196, 1);
          }

          .icon {
            display: flex;
            align-items: center;
            color: rgba(206, 206, 206, 0.6);
            margin-left: 0.2rem;
          }
        }
      }
    }
  }
}
</style>
